export default {
  common: {
    loading: 'Loading...',
    loadFailed: 'Failed to load. Please ensure the backend is running.',
    loadFailedShort: 'Failed to load',
    requestFailed: 'Request failed',
    submitFailed: 'Submission failed',
    articleNotFound: 'Article not found',
    siteSuffix: 'Official Site',
    industrialCorp: 'Industrial Corp.',
    home: 'Home',
    arrow: '→',
    back: '←',
    views: 'views',
    by: 'By',
  },
  nav: {
    contactUs: 'Contact Us',
    getQuote: 'Get Instant Quote',
    menu: 'Menu',
    routes: {
      home: 'Home',
      news: 'News',
      about: 'About',
      contact: 'Contact',
    },
  },
  footer: {
    aboutCompany: 'About Company',
    usefulLinks: 'Useful Links',
    services: 'Services',
    aboutUs: 'About Us',
    news: 'News',
    contact: 'Contact',
    office: 'Office',
    certifications: 'Certifications',
    serviceCnc: 'CNC Machining',
    serviceInjection: 'Injection Molding',
    serviceSheetMetal: 'Sheet Metal',
    servicePrinting: '3D Printing',
  },
  home: {
    heroTag: 'From Prototyping to Production',
    heroTitle: 'Quality Parts Made Easier, Faster',
    heroDesc: 'Your vision, our precision. From early prototypes to volume production—with speed, reliability, and consistent quality.',
    promoText: 'No CAD skills needed. Generate 3D models for prototyping and evaluation.',
    promoLink: 'Try It Now',
    quoteTitle: 'What Can We Help You With?',
    quoteName: 'Your Name',
    quoteEmail: 'Email',
    quotePhone: 'Phone',
    quoteCompany: 'Company',
    quoteMessage: 'Project Details',
    quoteSubmit: 'Submit Inquiry',
    quoteSubmitting: 'Submitting...',
    quoteSuccess: 'Submitted! We will contact you shortly.',
    getQuote: 'Get Instant Quote',
    servicesLabel: 'Manufacturing Services',
    servicesTitle: 'Manufacturing from Prototyping to Production',
    servicesDesc: 'In-house factory plus vetted supplier network—CNC, injection molding, sheet metal, 3D printing, and more for prototypes and volume runs.',
    toolsLabel: 'Smart Manufacturing',
    toolsTitle: 'The Tools to Manufacture Smarter',
    partnerLabel: 'Global Partner',
    partnerTitle: 'Your Trusted Manufacturing Partner in China. Global Shipping',
    partnerDesc: 'Based in China with in-house production and 700+ vetted partners. Delivery to North America and Europe in 3–10 days with English-speaking engineers.',
    platformLabel: 'Digital Platform',
    platformTitle: 'Manage Manufacturing Smarter with Our Digital Platform',
    platformDesc: 'From instant quotes and DFM analysis to order tracking and project management—all in one place.',
    processLabel: 'How It Works',
    processTitle: 'How to Work With Us',
    processCta: 'Start Your Instant Quote',
    qualityLabel: 'Quality Assurance',
    qualityTitle: 'Where Quality Meets Reliability',
    feedbackLabel: 'Customer Feedback',
    feedbackTitle: 'What Our Clients Say About Us',
    newsLabel: 'Manufacturing Resources',
    newsTitle: 'Industry Insights & Resources',
    viewAll: 'View All',
    ctaTitle: 'Book a Meeting with Our Experts',
    ctaDesc: 'Upload your drawings or describe your project for quotes, DFM feedback, and lead time estimates.',
    ctaButton: 'Get Instant Quote',
    contactUs: 'Contact Us',
    heroFallback1: 'PRECISION',
    heroFallback2: 'MANUFACTURER IN CHINA',
    factoryAlt: 'Factory',
  },
  about: {
    title: 'About Us',
    label: 'About Us',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Tell us about your project and we will get back to you shortly.',
    breadcrumb: 'Contact',
    getInTouch: 'Get In Touch',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    successTitle: 'Message Sent',
    successDesc: 'Thank you for reaching out. We will reply as soon as possible.',
    name: 'Name',
    company: 'Company',
    message: 'Message',
    required: '*',
    submitting: 'Submitting...',
    submit: 'Send Inquiry',
  },
  news: {
    title: 'News & Blog',
    subtitle: 'Industry insights and case studies',
    breadcrumb: 'News',
    empty: 'No articles yet',
    prev: 'Previous',
    next: 'Next',
    detailBreadcrumb: 'News',
    backToNews: 'Back to News',
  },
  article: {
    categoryNews: 'News',
  },
  faq: {
    label: 'FAQ',
    title: 'Frequently Asked Questions',
    subtitle: 'Common questions about our manufacturing capabilities and services',
  },
  meta: {
    home: 'Home',
    news: 'News',
    newsDetail: 'Article',
    about: 'About',
    contact: 'Contact',
  },
  sections: {
    productRange: {
      title: 'Product Range & Applications',
      description:
        'We recommend the optimal process based on your industry and design. Forging suits wider tolerances; forging plus CNC fits high-precision parts with better strength and lower total cost.',
      materials1: [
        'Aluminum alloys (4032-T6, 6061-T6, 7075-T6)',
        'Carbon steel (Q345, 42CrMo, AISI 4140)',
      ],
      materials2: [
        'Brass & bronze (H62, C3604, C5191)',
        'Stainless steel (303, 304, 316, 420, 431)',
      ],
    },
    aboutHighlights: [
      'ISO 9001 & IATF 16949 certified manufacturer',
      '13 forging lines, 65 CNC mills, 20 CNC lathes',
      '1,600-ton forging press, parts up to 500mm',
      'Full inspection lab with CMM, X-ray, and height gauges',
    ],
    stats: [
      { value: '26+', label: 'Years of Experience' },
      { value: '400+', label: 'Employees' },
      { value: '56,000 m²', label: 'Factory Area' },
      { value: '40+', label: 'Export Countries' },
    ],
    teamMembers: [
      { name: 'Mr. Zhang', role: 'Founder / CEO' },
      { name: 'Ms. Li', role: 'Deputy GM' },
      { name: 'Mr. Wang', role: 'Engineering Director' },
      { name: 'Ms. Chen', role: 'Purchasing Manager' },
      { name: 'Ms. Liu', role: 'Quality Manager' },
      { name: 'Mr. Zhao', role: 'Mold Design Manager' },
      { name: 'Mr. Huang', role: 'Plant Manager' },
    ],
    testimonials: [
      {
        text: 'On-time delivery, stable quality, and professional PPAP documentation make them our preferred long-term supplier.',
        author: '— Tier 1 Automotive Purchasing Director',
      },
      {
        text: 'From mold design to mass production, the team responded quickly with detailed DFM reports and shortened our development cycle.',
        author: '— New Energy Equipment Quality Manager',
      },
      {
        text: 'A reliable partner for global OEMs in medical, automotive, and new energy for over 26 years.',
        author: '— Telecom Equipment Engineering Director',
      },
    ],
    faqs: [
      {
        q: 'What is the minimum order quantity (MOQ)?',
        a: 'New tooling MOQ is typically 1,000 pcs; CNC-only runs start from 1 pc for prototyping and small batches.',
      },
      {
        q: 'Do you have export experience?',
        a: '18+ years in international trade, exporting to 40+ countries, familiar with IATF 16949, ISO 9001, RoHS, and REACH.',
      },
      {
        q: 'How do you ensure product quality?',
        a: 'ISO 9001 and IATF 16949 systems with CMM, spectrometer, tensile testers, and full IPQC/OQC coverage.',
      },
      {
        q: 'What is the typical lead time?',
        a: 'Tooling 3–5 weeks, samples 1–2 weeks depending on complexity; inquiries answered within 12 hours.',
      },
    ],
    certifications: [
      { label: 'ISO 9001' },
      { label: 'IATF 16949' },
    ],
    heroStats: [
      { value: '15+', label: 'Years Experience' },
      { value: '100,000+', label: 'Parts Manufactured' },
      { value: '700+', label: 'Manufacturing Centers' },
      { value: '98%', label: 'On-time Delivery' },
    ],
    services: [
      { title: 'CNC Machining', desc: 'Milling, turning & precision machining. ±0.001″ tolerance, 0.020″ thin walls, 1-day lead times.', slug: 'cnc' },
      { title: 'Injection Molding', desc: 'Plastic injection, overmolding & insert molding. No MOQ. T1 samples in 2 weeks. Scale 1 to 1M units.', slug: 'injection' },
      { title: 'Sheet Metal', desc: 'Laser cutting, bending, welding & stamping. 3-day lead time. 0.008 in. thin walls.', slug: 'sheet-metal' },
      { title: '3D Printing', desc: 'SLA, HP MJF, SLS & SLM for functional prototypes. ±0.008 in. precision. 1-day lead time.', slug: '3d-printing' },
      { title: 'Extrusion', desc: 'High-quality, low-cost metal extrusions with post-machining options. 2-week delivery.', slug: 'extrusion' },
      { title: 'Die Casting', desc: 'Aluminum/Zinc/Magnesium/Copper die casting. 0.03 in. walls, 1000+ unit batches.', slug: 'die-casting' },
      { title: 'Vacuum Casting', desc: 'Soft-tooled plastic prototypes. ±0.002″ precision, 20 parts in 15 days.', slug: 'vacuum-casting' },
      { title: 'Wire EDM', desc: 'Precision sinker & wire EDM for sharp corners and thin walls. Burr-free micromachining.', slug: 'wire-edm' },
    ],
    tools: [
      { title: 'Instant Quoting', desc: 'Upload 3D models for instant pricing, DFM, and production control.', cta: 'Upload & Quote', link: '/contact' },
      { title: 'Engineering Review', desc: 'No drawings yet? Describe your idea and get a manufacturability roadmap from our engineers.', cta: 'Talk to Engineers', link: '/contact' },
    ],
    partnerStats: [
      { value: '20,000+', label: 'Customers Worldwide' },
      { value: '120+', label: 'Countries & Regions' },
      { value: '700+', label: 'Machines Set' },
      { value: '56,000 m²', label: 'Factory Area' },
    ],
    factories: [
      { name: 'CNC Machining Shop', established: '2017', machines: '400 machines', location: 'Foshan' },
      { name: 'Sheet Metal Facility', established: '2020', machines: '51', location: 'Shenzhen' },
      { name: 'Injection Molding Factory', established: '2021', machines: '20', location: 'Shenzhen' },
      { name: '3D Printing Factory', established: '2019', machines: '285', location: 'Dongguan' },
    ],
    platformFeatures: [
      {
        title: 'Instant Quotation',
        desc: 'Accurate pricing and DFM feedback in seconds. Save time and keep projects on track.',
        points: ['No minimum order quantity', '100+ materials & 30 finishes', 'Flexible lead times & shipping'],
      },
      {
        title: 'Team Collaboration',
        desc: 'Share quotes and specs with one click. Centralize approvals and accelerate delivery.',
        points: ['One-click quote sharing', 'Centralized approvals', 'Dedicated account support'],
      },
      {
        title: 'Live Chat Support',
        desc: 'Instant expert support for quotes and orders. Share files and annotations in real time.',
        points: ['Quick quote & order help', 'Instant file sharing', 'Real-time design feedback'],
      },
      {
        title: 'Order Management',
        desc: 'One platform for quotations, orders, and production tracking with full transparency.',
        points: ['Real-time production tracking', 'High-res inspection photos', 'DFM to invoice documents'],
      },
    ],
    processSteps: [
      { title: 'Upload a CAD File', desc: 'Choose your process and upload your design file.', items: ['Select manufacturing process', 'Upload 2D/3D files', 'Specify material & quantity'] },
      { title: 'Get a Quote', desc: 'Configure details, receive pricing and DFM feedback, then place your order.', items: ['Instant or manual quote', 'DFM manufacturability review', 'Confirm lead time & shipping'] },
      { title: 'Parts Delivered!', desc: 'After production and QC, parts ship to your destination worldwide.', items: ['Full IPQC/OQC coverage', 'Inspection reports included', '3–10 day global shipping'] },
    ],
    qualityItems: [
      { title: 'Advanced Inspection Equipment', desc: 'CMM, 2D instruments, XRF, gauges, micrometers—20+ tool types for dimensions, materials, and finish.' },
      { title: 'Comprehensive Documentation', desc: 'FAI, RoHS compliance, dimensional measurements, and functional test reports for your QMS.' },
      { title: 'Certified Manufacturing Partner', desc: 'ISO 9001, IATF 16949 certified—trusted for automotive, medical, and consumer electronics.' },
    ],
  },
};
